const SPONSORS = [
  {
    title: "Traffic Rewards",
    desc: "Protein Box was chosen amongst the 100 selected partners for the Traffic Rewards Program, an initiative launched by Government of India and launched by Honourable Union Minister Nitin Gadkari ji",
    icon: "/images/sponsors/traffic-rewards.svg",
  },
  {
    title: "t-hub",
    desc: "Graduated at T-Hub, Hyderabad Start-up incubation centre (Lab 32, Cohort 10)",
    icon: "/images/sponsors/thub.svg",
  },
  {
    title: "University of Johannesburg",
    desc: "Protein Box has been studied in 2023 as part of a Group Syndicate Activity by the MBA students from the University of Johannesburg's Business School (JBS)",
    icon: "/images/sponsors/jbs.svg",
  },
  {
    title: "Tata Social Enterprise ",
    desc: "Protein Box was ranked amongst the top 100 start-up impact proposals conducted by Tata Social Enterprise Challenge & IIM Kolkata (2021-22)",
    icon: "/images/sponsors/tata.svg",
  },
  {
    title: "Money Control",
    desc: "Protein Box Health Food Brand mentioned by Money Control News Portal (April 2022 edition)",
    icon: "/images/sponsors/money-control.svg",
  },
  {
    title: "Leap to Unicorn",
    desc: "Protein Box has been shortlisted as top 400 start-ups in India amongst the 6000+ start-up applications in Leap to Unicorn Bootcamp conducted by IDFC Bank in association with Money Control & CNBC-TV18 (April 2023)",
    icon: "/images/sponsors/leap-to-unicorn.svg",
  },
  {
    title: "HPCL",
    desc: "Protein Box has officially received approval and will soon be signing an agreement with Hindustan Petroleum (HPCL) to establish Protein Box Healthy Meal Kiosks across prominent HPCL petrol pump locations.",
    icon: "/images/sponsors/hpcl.svg",
  },
];
export default SPONSORS;
